<template>
  <div id="app">
    <!-- changing header according to page -->
    <router-view name="Header"></router-view>
    <div id="developer">This website was created by Adele Angel</div>
    <router-view />

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/globals/Footer";

export default {
  name: "App",
  components: {
    Footer
  }
};
</script>